import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { ModalConfirmDialog } from '../components/ModalConfirmDialog'
import { errorMsg } from '../constants/messages'
import { useAuth } from '../hooks/useAuth'
import { AnonymousConversation } from '../pages/AnonymousConversation'
import { AnonymousLogin } from '../pages/AnonymousLogin'
import { AnonymousLoginExpired } from '../pages/AnonymousLoginExpired'
import { Conversation } from '../pages/Conversation'
import { ConversationLog } from '../pages/ConversationLog'
import { Conversion } from '../pages/Conversion'
import { CustomerInfoManagement } from '../pages/CustomerInfoManagement'
import { Device } from '../pages/Device'
import { DeviceList } from '../pages/DeviceList'
import { Email } from '../pages/Email'
import { EmailEntry } from '../pages/EmailEntry'
import { Illustration } from '../pages/Illustration'
import { ImportExport } from '../pages/ImportExport'
import { Login } from '../pages/Login'
import { SsoCallback } from '../pages/SsoCallback'
import { Logo } from '../pages/Logo'
import { Logout } from '../pages/Logout'
import { Mfa } from '../pages/Mfa'
import { NewPassword } from '../pages/NewPassword'
import { Password } from '../pages/Password'
import { Phrase } from '../pages/Phrase'
import { Signage } from '../pages/Signage'
import { User } from '../pages/User'
import { Word } from '../pages/Word'
import { PrivateRoute, SSO_RETURN_KEY } from './PrivateRoute'

const DcpRootRedirect = () => {
  // useEffect(() => {
  //   sessionStorage.setItem(SSO_RETURN_KEY, '/devicelicense')
  // }, [])
  return <Navigate to="/sso" replace />
}

export const CustomRouter = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  // ダイアログ
  const [openDialog, setOpenDialog] = useState(false)
  const [dialogType, setDialogType] = useState<'logout' | 'tabClose'>('logout')
  // 自動ログアウト監視
  useEffect(() => {
    if (auth.isAutoLogout) {
      auth.setIsAutoLogout(false)
      if (auth.isAnonymous) {
        // 匿名ログインの場合は自動ログアウトしない。
        // navigate("/expired");
      } else if (auth.isDisable) {
        // ローディング中も自動ログアウトしない。
      } else {
        setDialogType('logout')
        setOpenDialog(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAutoLogout])

  useEffect(() => {
    if (auth.isAutoTabClose) {
      auth.setIsAutoTabClose(false)
      if (auth.isAnonymous) {
        // 匿名ログインの場合は自動タブクローズしない。
      } else if (auth.isDisable) {
        // ローディング中も自動タブクローズしない。
      } else {
        setDialogType('tabClose')
        setOpenDialog(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAutoTabClose])

  const handleDialogClose = () => {
    setOpenDialog(false)
    const isDCP = window.location.hostname.endsWith('.' + process.env.REACT_APP_DCP_BASE_DOMAIN)
    navigate(isDCP ? '/logout?mode=autoClose' : '/logout')
  }
  // C805 会話記録URL発行対応
  const query = new URLSearchParams(window.location.search)
  const convId = query.get('convId')
  const conv = query.get('conv')
  const email = query.get('email')
  return (
    // アクティビティがあった場合にログアウトタイマーをリセットする
    <div onMouseMove={auth.handleActivity} onKeyDown={auth.handleActivity}>
      {openDialog && (
        <ModalConfirmDialog
          open={openDialog}
          text={dialogType === 'tabClose' ? errorMsg.SESSION_ERROR_TAB_CLOSE : errorMsg.SESSION_ERROR}
          buttonText="button_next"
          hideButton={dialogType === 'tabClose'}
          onClick={handleDialogClose}
        />
      )}
      <Routes>
        <Route
          path="/"
          element={
            window.location.hostname.endsWith('.' + process.env.REACT_APP_DCP_BASE_DOMAIN) ? (
              <DcpRootRedirect />
            ) : (
              <Login />
            )
          }
        />
        <Route
          path="/index.html"
          element={
            conv ? (
              <AnonymousConversation />
            ) : convId ? (
              <AnonymousLogin />
            ) : email ? (
              <NewPassword />
            ) : (
              <Login />
            )
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/sso" element={<SsoCallback />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/expired" element={<AnonymousLoginExpired />} />
        <Route
          path="/emailentry"
          element={
            <>
              <PrivateRoute>
                <EmailEntry passwordReset={false} />
              </PrivateRoute>
            </>
          }
        />
        <Route path="/passwordreset" element={<EmailEntry passwordReset={true} />} />
        <Route
          path="/mfa"
          element={
            <>
              <PrivateRoute>
                <Mfa />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/phrase"
          element={
            <>
              <PrivateRoute>
                <Phrase />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/word"
          element={
            <>
              <PrivateRoute>
                <Word />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/conversion"
          element={
            <>
              <PrivateRoute>
                <Conversion />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/importexport"
          element={
            <>
              <PrivateRoute>
                <ImportExport />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/illustration"
          element={
            <>
              <PrivateRoute>
                <Illustration />
              </PrivateRoute>
            </>
          }
        />

        <Route
          path="/logo"
          element={
            <>
              <PrivateRoute>
                <Logo />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/signage"
          element={
            <>
              <PrivateRoute>
                <Signage />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/email"
          element={
            <>
              <PrivateRoute>
                <Email />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/device"
          element={
            <>
              <PrivateRoute>
                <Device />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/conversationlog"
          element={
            <>
              <PrivateRoute>
                <ConversationLog />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/conversations"
          element={
            <>
              <PrivateRoute>
                <Conversation />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/password"
          element={
            <>
              <PrivateRoute>
                <Password />
              </PrivateRoute>
            </>
          }
        />
        <Route
          path="/user"
          element={
            <>
              <PrivateRoute>
                <User />
              </PrivateRoute>
            </>
          }
        />

        <Route
          path="/devicelist"
          element={
            <>
              <PrivateRoute>
                <DeviceList />
              </PrivateRoute>
            </>
          }
        />

        <Route
          path="/customerinfomanagement"
          element={
            <>
              <PrivateRoute>
                <CustomerInfoManagement/>
              </PrivateRoute>
            </>
          }
        />
        <Route path="*" element={<AnonymousLoginExpired />} />
      </Routes>
    </div>
  )
}
